module.exports = __webpack_public_path__ + "size4.png";